import { forwardRef } from 'react';
import { StyledSectionName } from './styled';

const SectionName = forwardRef((props, ref) => (
  <StyledSectionName ref={ref} {...props} />
));

export default SectionName;
